import { useEffect } from 'react';
import { PortfolioItem } from '@/mocks/portfolio';

interface Props {
  item: PortfolioItem;
  onClose: () => void;
}

export default function PortfolioModal({ item, onClose }: Props) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const handleKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handleKey);
    return () => { document.body.style.overflow = ''; window.removeEventListener('keydown', handleKey); };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="absolute inset-0 bg-black/85" />
      <div
        className="relative z-10 bg-white w-full max-w-4xl max-h-[90vh] flex flex-col md:flex-row overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Image */}
        <div className="md:w-2/3 bg-[#F5F5F5] flex items-center justify-center min-h-[300px] md:min-h-[500px]">
          <img src={item.imageUrl} alt={item.style} className="w-full h-full object-cover object-top" />
        </div>
        {/* Info */}
        <div className="md:w-1/3 p-8 md:p-10 flex flex-col justify-between">
          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-[#999] mb-2">{item.style}</p>
            <h3 className="text-xl font-semibold text-[#1A1A1A] mb-8">{item.artist}</h3>
            <div className="flex flex-col gap-4">
              {[
                { label: '작업 부위', value: item.bodyPart },
                { label: '소요 시간', value: item.duration },
                { label: '스타일', value: item.style },
              ].map((d) => (
                <div key={d.label} className="border-b border-[#F2F2F2] pb-4">
                  <p className="text-xs text-[#AAAAAA] mb-1">{d.label}</p>
                  <p className="text-sm text-[#1A1A1A]">{d.value}</p>
                </div>
              ))}
            </div>
          </div>
          <button
            onClick={onClose}
            className="mt-8 w-full py-3 border border-[#1A1A1A] text-sm tracking-widest uppercase text-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
